var _excluded = ["label", "renderLeftIcon", "disabled", "isSingleSelectable", "isMultiSelectable", "isExpanded", "isSelected", "treeId", "isAnyParentCollapsed", "depth", "renderExpandButton", "onExpand", "renderCheckbox", "onSelect", "renderLabel", "children"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { forwardRef, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AnimateHeight from '@adsk/alloy-react-animate-height';
import Checkbox from '@adsk/alloy-react-checkbox';
import { useForwardedRef } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import ExpandButton from './layout/ExpandButton';
import Label from './layout/Label';
var OUTSIDE_PADDING = 10;
var DEPTH_PADDING = 30;
var getLeftPadding = function getLeftPadding(props) {
  var amount = props.isExpandable ? OUTSIDE_PADDING + DEPTH_PADDING * props.depth : OUTSIDE_PADDING + DEPTH_PADDING * (props.depth + 1);
  return "".concat(amount, "px");
};
var filterDisabledAndHidden = function filterDisabledAndHidden(node) {
  return node.tabIndex !== -1;
};
var getAriaSelected = function getAriaSelected(_ref) {
  var isSingleSelectable = _ref.isSingleSelectable,
    isMultiSelectable = _ref.isMultiSelectable,
    isSelected = _ref.isSelected;
  if (isMultiSelectable) {
    return isSelected === true;
  }
  if (isSingleSelectable && isSelected) {
    return true;
  }
  return undefined;
};
var NestableTreeNodeLi = styled.li.attrs(function (p) {
  return _objectSpread(_objectSpread({}, p), {}, {
    role: 'treeitem'
  });
}).withConfig({
  displayName: "NestableTreeNode__NestableTreeNodeLi",
  componentId: "sc-cdc2s5-0"
})(["outline:none;display:flex;flex-flow:row nowrap;align-items:center;user-select:none;width:100%;height:40px;overflow:hidden;padding-left:", ";padding-right:10px;", " color:", ";&:disabled{cursor:default;color:", ";}"], getLeftPadding, function (props) {
  return (/* Add interactive styling */
    props.rowClick && "\n  cursor: ".concat(props.disabled ? 'default' : 'pointer', ";\n\n  background-color: ").concat(props.isSingleSelectable && props.isSelected ? theme.colors._adskBlue100Alpha : undefined, ";\n  &:focus,\n  &:hover {\n    background-color: ").concat(props.isSingleSelectable && props.isSelected ? undefined : theme.colors.charcoal050, ";\n  }\n  &:active {\n    background-color: ").concat(props.disabled ? undefined : theme.colors.charcoal100, ";\n  }\n  ")
  );
}, function (props) {
  return props.disabled ? theme.colors.charcoal500 : undefined;
}, theme.colors.charcoal500);
var NestableTreeNode = /*#__PURE__*/forwardRef(function (_ref2, forwardedRef) {
  var label = _ref2.label,
    renderLeftIcon = _ref2.renderLeftIcon,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$isSingleSelecta = _ref2.isSingleSelectable,
    isSingleSelectable = _ref2$isSingleSelecta === void 0 ? false : _ref2$isSingleSelecta,
    _ref2$isMultiSelectab = _ref2.isMultiSelectable,
    isMultiSelectable = _ref2$isMultiSelectab === void 0 ? false : _ref2$isMultiSelectab,
    _ref2$isExpanded = _ref2.isExpanded,
    isExpanded = _ref2$isExpanded === void 0 ? false : _ref2$isExpanded,
    _ref2$isSelected = _ref2.isSelected,
    isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected,
    _ref2$treeId = _ref2.treeId,
    treeId = _ref2$treeId === void 0 ? '' : _ref2$treeId,
    _ref2$isAnyParentColl = _ref2.isAnyParentCollapsed,
    isAnyParentCollapsed = _ref2$isAnyParentColl === void 0 ? false : _ref2$isAnyParentColl,
    _ref2$depth = _ref2.depth,
    depth = _ref2$depth === void 0 ? 0 : _ref2$depth,
    _ref2$renderExpandBut = _ref2.renderExpandButton,
    renderExpandButton = _ref2$renderExpandBut === void 0 ? function (p) {
      return /*#__PURE__*/React.createElement(ExpandButton, _extends({
        style: {
          margin: '0 3px'
        }
      }, p));
    } : _ref2$renderExpandBut,
    onExpand = _ref2.onExpand,
    _ref2$renderCheckbox = _ref2.renderCheckbox,
    renderCheckbox = _ref2$renderCheckbox === void 0 ? function (p) {
      return /*#__PURE__*/React.createElement(Checkbox, _extends({
        style: {
          margin: '0 7px'
        }
      }, p));
    } : _ref2$renderCheckbox,
    onSelect = _ref2.onSelect,
    _ref2$renderLabel = _ref2.renderLabel,
    renderLabel = _ref2$renderLabel === void 0 ? function (p) {
      return /*#__PURE__*/React.createElement(Label, p);
    } : _ref2$renderLabel,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var ref = useForwardedRef(forwardedRef);
  var isExpandable = children && onExpand && !!renderExpandButton;
  var rowClick = useMemo(function () {
    if (disabled) return undefined;
    // entire row click is for selection primarily
    if (isSingleSelectable || isMultiSelectable) {
      return onSelect ? function () {
        return onSelect({
          isSelected: !isSelected
        });
      } : undefined;
    }
    // if row isn't selectable, we can use the row click for expanding
    if (isExpandable) {
      return onExpand ? function () {
        return onExpand({
          isExpanded: !isExpanded
        });
      } : undefined;
    }
    // otherwise row is not clickable
    return undefined;
  }, [onSelect, onExpand, isSingleSelectable, isMultiSelectable, isExpandable, isExpanded, isSelected, disabled]);
  var handleKeyPress = useCallback(function (e) {
    if (e.code === 'Enter' || e.code === 'Space') {
      e.preventDefault();
      rowClick === null || rowClick === void 0 ? void 0 : rowClick();
    }
  }, [rowClick]);
  var moveElementFocus = useCallback(function (_ref3) {
    var event = _ref3.event,
      position = _ref3.position;
    event.preventDefault();
    if (position === 0) {
      return;
    }
    var treeRoot = document.getElementById(treeId);
    var allTreeNodeCollection = (treeRoot === null || treeRoot === void 0 ? void 0 : treeRoot.getElementsByTagName('li')) || [];
    var usableTreeNodes = Array.from(allTreeNodeCollection).filter(filterDisabledAndHidden);
    var currentNodeIndex = usableTreeNodes.indexOf(event.target);
    var newNodeIndex = currentNodeIndex + position;
    if (newNodeIndex >= 0 && newNodeIndex < usableTreeNodes.length) {
      var newNode = usableTreeNodes[newNodeIndex];
      newNode.focus();
    }
  }, [treeId]);
  var moveToNextNode = useCallback(function (event) {
    return moveElementFocus({
      event: event,
      position: 1
    });
  }, [moveElementFocus]);
  var moveToPreviousNode = useCallback(function (event) {
    return moveElementFocus({
      event: event,
      position: -1
    });
  }, [moveElementFocus]);
  var handleKeyDown = useCallback(function (e) {
    switch (e.code) {
      case 'ArrowDown':
        moveToNextNode(e);
        break;
      case 'ArrowUp':
        moveToPreviousNode(e);
        break;
      case 'ArrowRight':
        if (isExpandable) {
          if (isExpanded) {
            moveToNextNode(e);
          } else {
            onExpand({
              isExpanded: true
            });
          }
        }
        break;
      case 'ArrowLeft':
        if (isExpandable && isExpanded) {
          if (isExpanded) {
            onExpand({
              isExpanded: false
            });
          }
        } else if (depth > 0) {
          moveToPreviousNode(e);
        }
        break;
      default:
        break;
    }
  }, [moveToNextNode, moveToPreviousNode, isExpandable, isExpanded, depth, onExpand]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NestableTreeNodeLi, _extends({
    ref: ref,
    "aria-selected": getAriaSelected({
      isMultiSelectable: isMultiSelectable,
      isSingleSelectable: isSingleSelectable,
      isSelected: isSelected
    }),
    "aria-expanded": isExpandable && isExpanded,
    tabIndex: disabled || isAnyParentCollapsed ? -1 : 0,
    rowClick: !!rowClick,
    isSingleSelectable: isSingleSelectable,
    isExpandable: isExpandable,
    isSelected: !!isSelected,
    disabled: disabled,
    onClick: rowClick,
    depth: depth,
    onMouseEnter: function onMouseEnter() {
      var _ref$current;
      return !disabled && (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus());
    },
    onKeyPress: handleKeyPress,
    onKeyDown: handleKeyDown
  }, props), children && onExpand && renderExpandButton({
    isExpanded: isExpanded,
    onExpand: onExpand
  }), isMultiSelectable && renderCheckbox({
    disabled: disabled,
    checked: isSelected,
    onChange: function onChange(val) {
      return onSelect === null || onSelect === void 0 ? void 0 : onSelect({
        isSelected: val
      });
    }
  }), renderLeftIcon === null || renderLeftIcon === void 0 ? void 0 : renderLeftIcon({
    style: {
      /* total width must equal indent unit of 30 */
      margin: '0 3px',
      minWidth: 24
    }
  }), renderLabel({
    children: label
  })), children && /*#__PURE__*/React.createElement(AnimateHeight, {
    isOpen: isExpanded
  }, React.Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        depth: depth + 1,
        isAnyParentCollapsed: isAnyParentCollapsed || !isExpanded,
        treeId: treeId
      });
    }
    return child;
  })));
});
NestableTreeNode.displayName = 'TreeNode';
NestableTreeNode.propTypes = {
  /* Text to be rendered on the node */
  label: PropTypes.string.isRequired,
  /* The label render prop */
  renderLabel: PropTypes.func,
  /* The expand button render prop */
  renderExpandButton: PropTypes.func,
  /* The icon to render on the left side of the label */
  renderLeftIcon: PropTypes.func,
  /* The checkbox component to render in the case of a multi select tree */
  renderCheckbox: PropTypes.func,
  /* Determines if the node is currently disabled, if applicable */
  disabled: PropTypes.bool,
  /* Determines if the node is currently expanded, if applicable */
  isExpanded: PropTypes.bool,
  /* Determines if the node is currently selected, if applicable */
  isSelected: PropTypes.oneOf([true, false, 'indeterminate']),
  /* An internal prop that is injected into each child from the tree.
   * It is used to locate the tree root to enable navigation functionality */
  treeId: PropTypes.string,
  /* An internal prop that is recursively injected into each child tree node from its parent.
   * It handles disabling interactivity for hidden nodes */
  isAnyParentCollapsed: PropTypes.bool,
  /* An internal prop that is recursively injected into each child tree node from its parent.
   * It handles recording the current depth of the node, which increases at each level starting from zero. */
  depth: PropTypes.number,
  /* Handler for expanding the current node, in order to show its children */
  onExpand: PropTypes.func,
  /* Handler for selecting the current node */
  onSelect: PropTypes.func,
  /* Any child elements to override the default, exluding the indentation */
  children: PropTypes.node,
  /* style object to add to the wrapper of the node */
  style: stylePropType,
  /* className to add to the wrapper of the node */
  className: PropTypes.string,
  /* Determines if the node can be selected individually, if applicable */
  isSingleSelectable: PropTypes.bool,
  /* Determines if then node can be selected as a part of a group, if applicable */
  isMultiSelectable: PropTypes.bool
};
export default NestableTreeNode;
//# sourceMappingURL=NestableTreeNode.js.map